import type { ScreeningQuestionsConfig } from 'config-types/config/screening-questions';

export const patientScreeningQuestionsConfig: ScreeningQuestionsConfig = {
  title: 'ASK THE PATIENT',
  fields: [
    {
      id: 'seen_in_last_3_years',
      type: 'radio',
      question: 'Have you been seen by us in the last 3 years?',
      fhirField: 'seen-in-last-3-years',
      existsInQuestionnaire: true,
      options: [
        { value: 'yes', label: 'Yes', fhirValue: 'Yes' },
        { value: 'no', label: 'No', fhirValue: 'No' },
      ],
    },
    {
      id: 'pregnancy_status',
      type: 'radio',
      question: 'Is there any chance you could be pregnant?',
      fhirField: 'patient-pregnancy-status',
      options: [
        { value: 'yes', label: 'Yes', fhirValue: 'yes' },
        { value: 'no', label: 'No', fhirValue: 'no' },
        { value: 'not_sure', label: 'Not sure', fhirValue: 'not-sure' },
        { value: 'not_applicable', label: 'Not applicable', fhirValue: 'not-applicable' },
      ],
    },
    {
      id: 'breastfeeding_status',
      type: 'radio',
      question: 'Are you currently breastfeeding?',
      fhirField: 'patient-breastfeeding-status',
      options: [
        { value: 'yes', label: 'Yes', fhirValue: 'yes' },
        { value: 'no', label: 'No', fhirValue: 'no' },
        { value: 'not_applicable', label: 'Not applicable', fhirValue: 'not-applicable' },
      ],
    },
  ],
};
